<template>
  <div class="default-radio-buttons">
    <template v-for="option in options">
      <label
        @click="$emit('input', option.value)"
        class="radio-container"
        :class="{
          disabled: option.disabled,
        }"
      >
        <input
          type="radio"
          v-model="value"
          :value="option.value"
          :name="getUUID()"
          :disabled="option.disabled"
        />
        <span class="radiomark"></span>
        <div class="text">
          <p class="name">
            <b>{{ option.title }}</b>
          </p>
          <p class="description" v-if="option.description">
            {{ option.description }}
          </p>
        </div>
      </label>
    </template>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
export default {
  name: 'TjingRadioButtons',
  props: ['value', 'groupname', 'options'],
  data() {
    return {}
  },
  computed: {},
  methods: {
    getUUID() {
      return uuidv4()
    },
  },
  mounted() {},
  beforeCreate() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/Typography';

.default-radio-buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  gap: 16px;
}
p {
  line-height: 1.5rem;
  font-size: 1rem;
}

.description {
  color: $strom;
}

.disabled {
  pointer-events: none;
  h6,
  p {
    color: $blizzard;
  }
  .radio-container {
    cursor: default;
  }
}

.text {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.radio-container {
  position: relative;
  padding-left: 36px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: auto;
  min-height: 28px;
  display: flex;
  align-items: center;
}

/* Hide the browser's default radio button */
.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom radio button */
.radiomark {
  position: absolute;
  /*top: 50%;
    transform: translateY(-50%);*/

  top: 2px;
  left: 0;
  height: 22px;
  width: 22px;
  border: 2px solid $strom;
  border-radius: 50%;
  transition: all ease-in-out 0.3s;
}

/* On mouse-over, add a grey background color */
.radio-container:hover input ~ .radiomark {
  border: 2px solid $midnight;
}

.radio-container input:disabled ~ .radiomark {
  border: 2px solid $fog;
}
.radio-container:hover input:disabled ~ .radiomark {
  border: 2px solid $fog;
}

/* When the radio button is checked, add a blue background */
.radio-container input:checked ~ .radiomark {
  background-color: $twilight;
  border: 2px solid $twilight;

  &:hover {
    border: 2px solid $twilightshade;
  }
}
.radio-container input:checked:disabled ~ .radiomark {
  background-color: $fog;
  border: 2px solid $fog;
}
/* Create the indicator (the dot/circle - hidden when not checked) */
.radiomark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.radio-container input:checked ~ .radiomark:after {
  display: block;
}

.radio-container input:disabled ~ .radiomark:after {
  display: block;
}
/* Style the indicator (dot/circle) */
.radio-container .radiomark:after {
  top: 5px;
  left: 5px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}

@media (min-width: 480px) and (orientation: landscape) {
}

@media (min-width: 544px) {
}

@media (min-width: 768px) {
  .default-radio-buttons {
    gap: 20px;
  }
}

@media (min-width: 1200px) {
}
</style>
